'use client';

import { VIEW, queryStringConstants } from '@/constants/queryConstants';
import useMap from '@/hooks/useMap';
import { useSearchParams } from 'next/navigation';
import { useMemo, type ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export default function FeaturedVenuesContainer({ children }: Props): JSX.Element | null {
  const { mapExpanded } = useMap();
  const searchParams = useSearchParams();
  const view = useMemo(() => searchParams?.get(queryStringConstants.VIEW), [searchParams]);
  if (mapExpanded || view === VIEW.FULL_MAP) {
    return null;
  }
  return <div data-cvent-id="featured-venues-container">{children}</div>;
}
